import React from 'react'
import {Icon} from '@chakra-ui/react'

const CardPaymentIcon = (props) => {
    return (
        <Icon viewBox="0 0 49 48" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M10.6833 7.99205C10.6833 6.21704 12.1333 4.80005 13.8753 4.80005H44.8295C46.57 4.80005 48.0205 6.21751 48.0205 7.99205V28.6282C48.0205 30.3482 46.549 31.8192 44.8295 31.8192H19.9809C19.4395 31.8192 19.0007 31.3804 19.0007 30.8391C19.0007 30.2978 19.4395 29.8589 19.9809 29.8589H44.8295C45.4665 29.8589 46.0602 29.2654 46.0602 28.6282V15.9735L11.6634 15.9735C11.1221 15.9735 10.6833 15.5347 10.6833 14.9933V7.99205ZM12.6436 8.85403V7.99205C12.6436 7.30994 13.206 6.76037 13.8753 6.76037H44.8295C45.4974 6.76037 46.0602 7.31041 46.0602 7.99205V8.85403H12.6436ZM46.0602 10.8144V14.0132H12.6436V10.8144H46.0602Z"
                fill="currentColor"
            />
            <path
                d="M7.89187 36.1475V32.3075C7.89187 31.7773 8.32168 31.3475 8.85187 31.3475C9.38207 31.3475 9.81187 31.7773 9.81187 32.3075V36.1475C9.81187 36.6777 9.38207 37.1075 8.85187 37.1075C8.32168 37.1075 7.89187 36.6777 7.89187 36.1475Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.7434 25.7906H15.9348V24.036C15.9348 20.1247 12.7633 16.9532 8.85197 16.9532C4.94 16.9532 1.76909 20.1244 1.76909 24.036V25.7906H0.96C0.429807 25.7906 0 26.2204 0 26.7506V41.7036C0 42.2338 0.429807 42.6636 0.96 42.6636H16.7434C17.2736 42.6636 17.7034 42.2338 17.7034 41.7036V26.7506C17.7034 26.2204 17.2736 25.7906 16.7434 25.7906ZM2.72909 27.7109L2.70526 27.7106H1.92V40.7436H15.7834V27.7106H14.9987L14.9748 27.7109L14.951 27.7106H2.75291L2.72909 27.7109ZM14.0148 24.036V25.7906H3.68909V24.036C3.68909 21.1848 6.00044 18.8732 8.85197 18.8732C11.7029 18.8732 14.0148 21.1851 14.0148 24.036Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M34.2883 27.2249H43.1318C43.7013 27.2249 44.1629 26.7633 44.1629 26.1938V20.2975C44.1629 19.7281 43.7013 19.2665 43.1318 19.2665H34.2883C33.7189 19.2665 33.2573 19.7281 33.2573 20.2975V26.1938C33.2573 26.7633 33.7189 27.2249 34.2883 27.2249ZM35.3194 21.3286H42.1008V25.1628H35.3194V21.3286Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default CardPaymentIcon
